import React, { useEffect, useState, useCallback } from "react";

import { UncontrolledCollapse, Table, Col, Container, Row, Card, CardBody, Input, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, Form, ModalBody, ModalFooter, Label, ModalHeader, FormFeedback, Spinner, CardHeader, CardFooter } from "reactstrap";
import Flatpickr from "react-flatpickr";
import { isEmpty, clone } from "lodash";

import logo from "../../../../assets/images/users/user-dummy-img.jpg";

import Board from "react-trello";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import Select from "react-select";
import moment from "moment";
import CardBoard from "./CardBoard";

import logoDark from "../../../../assets/images/logo-dark.png";
import logoLight from "../../../../assets/images/logo-light.png";

// Import actions
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { api } from "../../../../config";
import { Link } from "react-router-dom";
import defaultImg from "../../../../assets/images/users/user-dummy-img.jpg";
import ModalInputFile from "../../../../Components/ModalInputFile";

// import { resetSalesChannelState, getSalesChannel } from "../../../../store/salesChannel/action";
import { getAgent, resetAgentState } from "../../../../store/agent/action";
import { getMarital, resetMaritalState } from "../../../../store/marital/action";
import { resetSalesBookState, getSalesBook as onGetSalesBooks, addNewSalesBook as onAddNewSalesBook, updateSalesBook as onUpdateSalesBook, deleteSalesBook as onDeleteSalesBook, getSalesBookLoading, resetSalesBookCreateState } from "../../../../store/salesBook/action";
import { getDeal as onGetDeals, addNewDeal as onAddNewDeals, updateDeal as onUpdateDeals, deleteDeal as onDeleteDeals, resetDealState } from "../../../../store/deal/action";
import { resetCompanyState, getCompany } from "../../../../store/company/action";
import { resetClientState, getClient } from "../../../../store/client/action";
import { resetBranchState, getBranch } from "../../../../store/branch/action";
import { resetBrandState, getBrand } from "../../../../store/brand/action";
import { resetDealTagState, getDealTag, addNewDealTag } from "../../../../store/dealTag/action";
import { resetCustomerState, getCustomer } from "../../../../store/customer/action";
import { resetContactState, getContact } from "../../../../store/contact/action";
import { resetDealStatusState, getDealStatus } from "../../../../store/dealStatus/action";
import { resetProductVarianState, getProductVarian } from "../../../../store/productVarian/action";
import { getAccAccount, resetAccAccountState } from "../../../../store/accAccount/action";
import { getPaymentMethod, resetPaymentMethodState } from "../../../../store/paymentMethod/action";
import { getPaymentTerm, resetPaymentTermState } from "../../../../store/paymentTerm/action";
import { getTransactionTax, resetTransactionTaxState } from "../../../../store/transactionTax/action";
import handleValidDate from "../../../../helpers/utils/handleValidDate";
import handleValidDateTime from "../../../../helpers/utils/handleValidDateTime";

const CrmDeals = () => {
  const dispatch = useDispatch();

  const { maritals, maritalLoading, isDealCreated, transactionTaxs, transactionTaxLoading, accAccounts, accAccountLoading, shipmentMethodLoading, shipmentMethods, paymentMethodLoading, paymentMethods, paymentTermLoading, paymentTerms, agents, agentLoading, salesBookAdded, salesBooks, assets, assetLoading, customerLoading, deals, companies, companyLoading, clientLoading, clients, productVarians, productVarianLoading, branches, branchLoading, brands, brandLoading, dealTags, dealTagLoading, customers, contacts, loading, dealStatus } = useSelector((state) => ({
    deals: state.Deal.deals,
    loading: state.Deal.loading,
    isDealCreated: state.Deal.isDealCreated,
    salesBookAdded: state.SalesBook.salesBookAdded,
    salesBooks: state.SalesBook.salesBooks,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    dealTags: state.DealTag.dealTags,
    dealTagLoading: state.DealTag.loading,
    contacts: state.Contact.contacts,
    dealStatus: state.DealStatus.dealStatus,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    customers: state.Customer.customers,
    customerLoading: state.Customer.loading,
    assets: state.Asset.assets,
    assetLoading: state.Asset.loading,
    agents: state.Agent.agents,
    agentLoading: state.Agent.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    paymentTerms: state.PaymentTerm.paymentTerms,
    paymentTermLoading: state.PaymentTerm.loading,
    shipmentMethods: state.ShipmentMethod.shipmentMethods,
    shipmentMethodLoading: state.ShipmentMethod.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    maritalLoading: state.Marital.loading,
    maritals: state.Marital.maritals,
  }));

  const [dataBoard, setDataBoard] = useState({ lanes: [] });
  const [id, setId] = useState(null);
  const [salesBook, setSalesBook] = useState([]);
  const [submitDoc, setSubmitDoc] = useState(null);
  const [followUpData, setFollowUpData] = useState({});
  const [purDocImg, setPurDocImg] = useState([]);
  const [modal, setModal] = useState(false);
  const [deal, setDeal] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [agentList, setAgentList] = useState([]);
  // const [salesChannelList, setSalesChannelList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [maritalList, setMaritalList] = useState([]);
  const [dealTagList, setDealTagList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [modalMedia, setModalMedia] = useState(false);
  const [modalMediaBooking, setModalMediaBooking] = useState(false);
  const [modalMediaSubmitDoc, setModalMediaSubmitDoc] = useState(false);
  const [dealFiles, setDealFiles] = useState([]);

  const [modalBooking, setModalBooking] = useState(false);
  const [modalSubmitDoc, setModalSubmitDoc] = useState(false);
  const [modalFollowUp, setModalFollowUp] = useState(false);
  const [dealStatusList, setDealStatusList] = useState([]);
  const [dealList, setDealList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [salesBookDetailItem, setSalesBookDetailItem] = useState([]);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");

  const [dataCardBooking, setDataCardBooking] = useState({
    id: "",
    type: "",
    companyId: "",
    clientId: "",
    statusDealId: "",
  });

  const [dataCardSubmitDoc, setDataCardSubmitDoc] = useState({
    id: "",
    type: "",
    companyId: "",
    clientId: "",
    statusDealId: "",
  });

  const [subTotal, setSubTotal] = useState(0);
  const [ship, setShip] = useState(0);
  const [tax, setTax] = useState(0);
  const [dis, setDis] = useState(0);

  const statusSalesBookData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const statusActiveData = [
    {
      options: [
        { label: "BTN BOGOR", value: "BTN BOGOR" },
        { label: "BTN CAWANG", value: "BTN CAWANG" },
        { label: "BTN BEKASI", value: "BTN BEKASI" },
        { label: "BTN HARAPAN INDAH", value: "BTN HARAPAN INDAH" },
        { label: "BTN CIBUBUR", value: "BTN CIBUBUR" },
        { label: "BTN KEBON JERUK", value: "BTN KEBON JERUK" },
        { label: "BTN CIBINONG", value: "BTN CIBINONG" },
        { label: "BTN CIMANGGU", value: "BTN CIMANGGU" },
        { label: "BTN SYARIAH BOGOR", value: "BTN SYARIAH BOGOR" },
        { label: "BTN SYARIAH HARMONI", value: "BTN SYARIAH HARMONI" },
      ],
    }];

  const sortbyname = [
    {
      options: [
        { label: "Owner", value: "Owner" },
        { label: "Company", value: "Company" },
        { label: "Location", value: "Location" },
      ],
    }];

  const searchHandleDeal = (searchTerm) => {
    if (searchTerm === "") {
      dispatch(onGetDeals());
    } else {
      let result = deals.filter((o) => o.deal_customer.name.toLowerCase().includes(searchTerm.toLowerCase()));
      setDealList(result);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj.data && obj?.data?.user) {
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });

        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });
        validation.setFieldValue("client", {
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        validation.setFieldValue("company", {
          label: obj.data.company_name,
          value: obj.data.companyId
        });
        setIsSearch(true)

        dispatch(resetDealState());
        dispatch(onGetDeals({ companyId: obj.data.companyId }));
        dispatch(resetDealStatusState());
        dispatch(getDealStatus({ status: 2 }));
        dispatch(resetDealTagState());
        dispatch(getDealTag({ companyId: obj.data.companyId }));
        dispatch(resetCustomerState());
        dispatch(getCustomer({ companyId: obj.data.companyId }));
        dispatch(resetContactState());
        dispatch(getContact({ companyId: obj.data.companyId }));
        dispatch(resetAgentState());
        dispatch(getAgent({ companyId: obj.data.companyId }));
        setIsSearch(true);

        dispatch(getClient());
        dispatch(getCompany({ companyId: obj.data.companyId }));
        dispatch(getTransactionTax({ companyId: obj.data.companyId }));
        dispatch(getAccAccount({ companyId: obj.data.companyId }));
        dispatch(getPaymentMethod({ companyId: obj.data.companyId }));
        dispatch(getPaymentTerm({ companyId: obj.data.companyId }));
        dispatch(getProductVarian({ type: "referral", companyId: obj.data.companyId }));
        dispatch(getMarital({ companyId: obj.data.companyId }));

        dispatch(resetBranchState());
        dispatch(getBranch({ companyId: obj.data.companyId }));

        dispatch(resetBrandState());
        dispatch(getBrand({ branchId: obj.data.companyId }));

        dispatch(resetProductVarianState());
        dispatch(getProductVarian({ companyId: obj.data.companyId, type: "referral" }));
      }
    }
  }, [dispatch, isSearch]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setIsEdit(false);
      setDeal(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
      dispatch(getClient());
      setDealFiles([]);
    }
  }, [modal]);

  const toggleBooking = useCallback(() => {
    if (modalBooking) {
      setModalBooking(false);
      setIsEdit(false);
      setSalesBook(null);
      setSelectedFiles([]);
      setOriginalFiles([]);
    } else {
      setModalBooking(true);
    }
  }, [modalBooking]);

  const toggleSubmitDoc = useCallback(() => {
    if (modalSubmitDoc) {
      setModalSubmitDoc(false);
      setIsEdit(false);
      validationSubmitDoc.resetForm();
    } else {
      setModalSubmitDoc(true);
    }
  }, [modalSubmitDoc]);

  useEffect(() => {
    if (isDealCreated) {
      dispatch(onGetDeals());
    }
  }, [isDealCreated]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleFollowUp = useCallback(() => {
    if (modalFollowUp) {
      setModalFollowUp(false);
      setFollowUpData(null);
      dispatch(onGetDeals());
    } else {
      setModalFollowUp(true);
    }
  }, [modalFollowUp]);

  const toggleMediaBooking = useCallback(() => {
    if (modalMediaBooking) {
      setModalMediaBooking(false);
    } else {
      setModalMediaBooking(true);
    }
  }, [modalMediaBooking]);

  const toggleMediaSubmitDoc = useCallback(() => {
    if (modalMediaSubmitDoc) {
      setModalMediaSubmitDoc(false);
    } else {
      setModalMediaSubmitDoc(true);
    }
  }, [modalMediaSubmitDoc]);

  const handleStartAt = (date) => {
    validation.setFieldValue("startat", date);
  };

  const handleEndAt = (date) => {
    validation.setFieldValue("endat", date);
  };

  const handleDocumentAt = (date) => {
    validation.setFieldValue("documentat", date);
  };

  const handleSp3at = (date) => {
    validation.setFieldValue("sp3at", date);
  };

  const handleBankat = (date) => {
    validation.setFieldValue("bankat", date);
  };

  const onClickDeleteDetailItem = (index) => {
    const arrayCopy = [...validation.values.items];
    arrayCopy.splice(index, 1);
    validation.setFieldValue("items", arrayCopy);
  };

  function handleSalesDetailAdd() {
    validation.setFieldValue("items", [...validation.values.items, { productVarianId: 0, productId: 0 }]);
  }

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian_name = item.pvar_product.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });

        var obj = { label: varian_name + " " + option_name.slice(0, -1) + " - " + barcode, name: varian_name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId };
        opt.push(obj);
      });
      var option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(maritals)) {
      var data = [];
      var opt = [];
      maritals.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setMaritalList(data);
    }
  }, [maritals]);

  useEffect(() => {
    if (!isEmpty(customers)) {
      var data = [];
      var opt = [];
      customers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCustomerList(data);
    }
  }, [customers]);

  useEffect(() => {
    if (!isEmpty(dealStatus)) {
      var data = [];
      var opt = [];
      dealStatus.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setDealStatusList(data);
    }
  }, [dealStatus]);

  useEffect(() => {
    if (!isEmpty(contacts)) {
      var data = [];
      var opt = [];
      contacts.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setContactList(data);
    }
  }, [contacts]);

  useEffect(() => {
    if (!isEmpty(dealTags)) {
      var data = [];
      var opt = [];
      dealTags.forEach((item, key) => {
        const tag_name = item.name;
        const id = item.id;
        var obj = { label: tag_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setDealTagList(data);
    }
  }, [dealTags]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    var data = [];
    var opt = [];
    brands.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (brands.length > 0) {
      setBrandList(data);
    }
  }, [brands]);

  useEffect(() => {
    var data = [];
    var opt = [];
    agents.forEach((item, key) => {
      const name = item.name;
      const id = item.userId;
      const userId = item.userId;
      var obj = { label: name, value: id, userId: userId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (agents.length > 0) {
      setAgentList(data);
    }
  }, [agents]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (!isEmpty(paymentTerms)) {
      var data = [];
      var opt = [];
      paymentTerms.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentTermList(data);
    }
  }, [paymentTerms]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(transactionTaxs)) {
      var data = [];
      var opt = [];
      transactionTaxs.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const amount = parseInt(item.amount) || 0;
        var obj = { label: name, value: id, amount: amount };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTaxList(data);
    }
  }, [transactionTaxs]);

  const handleDeleteFileBooking = (file) => {
    if (isEdit) {
      const newState = purDocImg.map((obj) => {
        if (obj.id === file.id) {
          return { id: file.id, filename: file.filename, originalname: file.originalname, mimetype: file.mimetype, isDeleted: true };
        }
        return obj;
      });
      setPurDocImg(newState);
    } else {
      const index = purDocImg.findIndex((fl) => fl.filename === file.filename);
      setPurDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFileBooking = (file) => {
    setPurDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMediaBooking();
  };

  const handleDeleteFileSubmitDoc = (file) => {
    if (isEdit) {
      const newState = purDocImg.map((obj) => {
        if (obj.id === file.id) {
          return { id: file.id, filename: file.filename, originalname: file.originalname, mimetype: file.mimetype, isDeleted: true };
        }
        return obj;
      });
      setPurDocImg(newState);
    } else {
      const index = purDocImg.findIndex((fl) => fl.filename === file.filename);
      setPurDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFileSubmitDoc = (file) => {
    setPurDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);

    toggleMediaSubmitDoc();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = validation.values.file.map((obj) => {
        if (obj.id === file.id) {
          return { id: file.id, filename: file.filename, originalname: file.originalname, mimetype: file.mimetype, isDeleted: true };
        }
        return obj;
      });
      validation.setFieldValue("file", newState);
    } else {
      const index = dealFiles.findIndex((fl) => fl.filename === file.filename);
      const newState = [...validation.values.file.slice(0, index), ...validation.values.file.slice(index + 1)];
      validation.setFieldValue("file", newState);
    }
  };

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      case "files":
        validation.setFieldValue("file", [...validation.values.file, { filename: file.filename, originalname: file.originalname }]);
        break;
      case "imageVarian":
        validation.setFieldValue("imageVarian", file.filename);
        break;
      default:
        validation.setFieldValue("file", [...validation.values.file, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  function handleGetProductVariant(companyId) {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  }

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = (id) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: id }));
  };

  const handleGetBrand = (id) => {
    dispatch(resetBrandState());
    dispatch(getBrand({ branchId: id }));
  };

  function handleGetCustomer(companyId) {
    dispatch(resetCustomerState());
    dispatch(getCustomer({ companyId: companyId }));
  }
  const handleGetAgent = (id = "") => {
    dispatch(resetAgentState());
    dispatch(getAgent({ companyId: id }));
  };

  useEffect(() => {
    setDealList(deals);
  }, [deals]);

  useEffect(() => {
    if (!isEmpty(dealStatus)) {
      let l = [];

      dealStatus.forEach((el) => {
        l.push({
          id: el.id.toString(),
          sortOrder: el.sort_order,
          title: el.name,
          style: {
            width: 280,
          },
          cards: [],
        });
      });

      l.forEach((el) => {
        dealList.forEach((e) => {
          if (e.statusDealId !== null) {
            if (el.id.toString() === e.statusDealId.toString()) {
              el.cards.push({
                description: e.description === "" ? "-" : e.description,
                id: e.id.toString(),
                image: e.image,
                startat: moment(e.startat, "YYYY/MM/DD").format("MMM D, YYYY"),
                endat: moment(e.endat, "YYYY/MM/DD").format("MMM D, YYYY"),
                laneId: el.id.toString(),
                statusDealId: e.statusDealId,
                dealUser: e.deal_user === null ? [] : e.deal_user,
                dealProduct: e.deal_product === null ? [] : e.deal_product,
                value: Math.round(e.value, 0),
                customer: e.deal_customer.name,
                history: e.deal_history === null ? [] : e.deal_history,
                data: e,
              });
            }
          }
        });
      });

      setDataBoard((val) => {
        return {
          ...val,
          lanes: l,
        };
      });
    }
  }, [dealStatus, dealList]);

  const handleFollowUpClick = useCallback((arg, type) => {
      const data = arg;
      let stat = 3;

      switch (type) {
        case "Approve Document":
          stat = 5;
          break;
        case "Reject Document":
          stat = 3;
          break;
        case "Approve Bank":
          stat = 6;
          break;
        case "Reject Banding Bank":
          stat = 4;
          break;
        case "Reject Bank":
          stat = 8;
          break;
        default:
      }

      setFollowUpData({
        id: data.id,
        type: type,
        companyId: data.companyId,
        clientId: data.clientId,
        statusDealId: stat,
      });
      toggleFollowUp();
    }, [toggleFollowUp]);

  const handleContactClick = useCallback((arg) => {
    const dealData = arg;
    let tag = [];

    if (dealData.tag) {
      dealData.tag.forEach((item) => {
        const label = item.label;
        const id = item.value;
        var obj = { label: label, value: id };
        tag.push(obj);
      });
    }

    let dealUser = [];

    if (dealData.deal_user) {
      dealData.deal_user.forEach((item) => {
        const label = item.deal_user_user.name;
        const id = item.deal_user_user.id;
        var obj = { label: label, value: id };
        dealUser.push(obj);
      });
    }

    let itemDetail = [];

    if (dealData.deal_product.length > 0) {
      for (const el of dealData.deal_product) {
        let itm = { label: el.deal_product_product.name, value: el.deal_product_product.id };

        itemDetail.push({
          item: itm,
          productVarianId: el.productVarianId,
          productId: el.productId,
        });
      }
    }

    let files = [];
    for (const f of dealData.deal_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }

    setDeal({
      id: dealData.id,
      image: dealData.image,
      statusDealId: dealData.statusDealId,
      description: dealData.description,
      value: Math.round(dealData.value, 0),
      tag: tag,
      customer: dealData.deal_customer === null ? "" : {
        label: dealData.deal_customer ? dealData.deal_customer.name : "",
        value: dealData.deal_customer ? dealData.deal_customer.id : "",
      },
      bank: {
        label: dealData.bank,
        value: dealData.bank,
      },
      status: dealData.deal_status === null ? "" : {
        label: dealData.deal_status.id === 1 ? "Approved" : dealData.deal_status.id === 2 ? "Rejected Appeal" : dealData.deal_status.id === 3 ? "Rejected" : "",
        value: dealData.deal_status ? dealData.deal_status.id : "",
      },
      client: dealData.deal_client === null ? "" : {
        label: dealData.deal_client ? dealData.deal_client.name : "",
        value: dealData.deal_client ? dealData.deal_client.id : "",
      },
      company: dealData.deal_company === null ? "" : {
        label: dealData.deal_company ? dealData.deal_company.name : "",
        value: dealData.deal_company ? dealData.deal_company.id : "",
      },
      branch: dealData.deal_branch === null ? "" : {
        label: dealData.deal_branch ? dealData.deal_branch.name : "",
        value: dealData.deal_branch ? dealData.deal_branch.id : "",
      },
      brand: dealData.deal_brand === null ? "" : {
        label: dealData.deal_brand ? dealData.deal_brand.name : "",
        value: dealData.deal_brand ? dealData.deal_brand.id : "",
      },
      file: files,
      startat: dealData.startat,
      endat: dealData.endat,
      bankat: dealData.bankat,
      documentat: dealData.documentat,
      sp3at: dealData.sp3at,
      dealuser: dealUser,
      name: dealData.name,
      statusDeal: dealData.deal_status_type === null ? "" : {
        label: dealData.deal_status_type ? dealData.deal_status_type.name : "",
        value: dealData.deal_status_type ? dealData.deal_status_type.id : "",
      },
      items: itemDetail,
    });

    handleGetCompany(dealData.deal_client.id);
    handleGetBrand(dealData.deal_company.id);
    handleGetBranch(dealData.deal_company.id);
    handleGetProductVariant(dealData.deal_company.id);

    setIsEdit(true);
    toggle();
  }, [toggle]);


  const validationFollowUp = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      const data = {
        id: followUpData.id,
        type: followUpData.type,
        companyId: followUpData.companyId,
        clientId: followUpData.clientId,
        statusDealId: followUpData.statusDealId,
        description: values.description,
      };

      dispatch(onUpdateDeals(data));

      validationFollowUp.resetForm();
      toggleFollowUp();
      setModalSubmitDoc(false);
    },
  });

  function handleToggleBooking(dd, object) {
    setDataCardBooking(dd);
    const data = object.deal_book[0] || {};

    let salesBookDetail = [];

    setSubTotal(parseInt(data.sub_amount));
    setShip(parseInt(data.shipmentAmount));
    setTax(parseInt(data.sales_book_tax ? data.sales_book_tax.amount : 0));
    setDis(parseInt(data.disc_amount));

    // setSalesBookType(data.type);
    if (data.sales_book_detail) {
      data.sales_book_detail.forEach((element) => {
        salesBookDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          item: { label: element.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          accepted: element.accepted ? Math.round(element.accepted, 0) : 0,
          rejected: element.rejected ? Math.round(element.rejected, 0) : 0,
        });
      });
      setSalesBookDetailItem(salesBookDetail);
    }


    dispatch(getProductVarian({ type: "referral" }));

    let files = [];
    for (const f of data.sales_book_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setOriginalFiles(files);
    setPurDocImg(files);

    if (data.sales_book_company !== null) {
      handleGetBranch(data.sales_book_company.id);
    }

    setSalesBook({
      id: data.id,
      description: data.description,
      dueat: data.dueat,
      date: data.transactionat,
      code: data.code === null ? "-" : data.code,
      discount: data.disc_amount === null ? 0 : parseInt(data.disc_amount, 10),
      accAccount:
        data.sales_book_acc_account && {
          label: data.sales_book_acc_account.name,
          value: data.sales_book_acc_account.id,
        },
      tax:
        data.sales_book_tax && {
          label: data.sales_book_tax.name,
          value: data.sales_book_tax.id,
          amount: parseInt(data.sales_book_tax.amount, 10),
        },
      branch:
        data.sales_book_branch == null
          ? ""
          : {
            label: data.sales_book_branch.name,
            value: data.sales_book_branch.id,
          },
      client:
        data.sales_book_client && {
          label: data.sales_book_client.name,
          value: data.sales_book_client.id,
        },
      company:
        data.sales_book_company == null
          ? ""
          : {
            label: data.sales_book_company.name,
            value: data.sales_book_company.id,
          },
      paymentMethod:
        data.sales_book_pm && {
          label: data.sales_book_pm.name,
          value: data.sales_book_pm.id,
        },
      paymentTerm:
        data.sales_book_payment_term && {
          label: data.sales_book_payment_term.name,
          value: data.sales_book_payment_term.id,
        },
      customer:
        data.sales_book_customer && {
          label: data.sales_book_customer.name,
          value: data.sales_book_customer.id,
        },
      salesChannel: data.sales_book_channel && { label: data.sales_book_channel.name, value: data.sales_book_channel.id },
      taxAmount: data.tax_amount === null ? 0 : Math.round(data.tax_amount, 0),
      totalAmount: data.total_amount === null ? 0 : Math.round(data.total_amount, 0),
      status: data.sales_book_status && { label: data.sales_book_status.name, value: data.sales_book_status.id },
      tax_amount: data.tax_amount === null ? 0 : Math.round(data.tax_amount, 0),
      total_amount: data.total_amount === null ? 0 : Math.round(data.total_amount, 0),
      sub_amount: data.sub_amount === null ? 0 : Math.round(data.sub_amount, 0),
      adminFee: 0,
    });

    toggleBooking();
  }


  function handleToggleSubmitDoc(data, object) {
    setDataCardSubmitDoc(data);
    setDeal(object);

    let files = [];

    if (object.deal_file.length > 0) {
      object.deal_file.forEach((element) => {
        files.push({
          filename: element.filename,
        });
      });
    }

    let applicantData = {};

    if (object.deal_applicant != null) {
      applicantData = {
        maritalStatus:
          object.deal_applicant.applicant_marital_status && {
            label: object.deal_applicant.applicant_marital_status ? object.deal_applicant.applicant_marital_status.name : "",
            value: object.deal_applicant.applicant_marital_status ? object.deal_applicant.applicant_marital_status.id : "",
          },
        name: object.deal_applicant.name,
        email: object.deal_applicant.email,
        phone: object.deal_applicant.phone,
        allocation: object.deal_applicant.allocation,
        creditPeriod: object.deal_applicant.credit_period,
        downPayment: object.deal_applicant.down_payment,
        childrenNumber: object.deal_applicant.children_number,
        nameSpouse: object.deal_applicant.name_spouse,
        phoneSpouse: object.deal_applicant.phone_spouse,
        knownCrApplication: object.deal_applicant.knownCrApplication,
        emergencyContactName: object.deal_applicant.emergency_contact_name,
        emergencyContactPhone: object.deal_applicant.emergency_contact_phone,
        emergencyContactRelation: object.deal_applicant.emergency_contact_relation,
        emergencyKnownCrApplication: object.deal_applicant.emergencyKnownCrApplication,
        jobInformanName: object.deal_applicant.job_informan_name,
        jobInformanPosition: object.deal_applicant.job_informan_position,
        jobBusiness: object.deal_applicant.job_business,
        jobBusinessEmployee: object.deal_applicant.job_business_employee,
        jobBusinessDate: object.deal_applicant.job_business_date,
        jobPosition: object.deal_applicant.job_position,
        jobDate: object.deal_applicant.job_date,
        jobStatus: object.deal_applicant.job_status,
        jobPayRate: object.deal_applicant.job_pay_rate,
        jobPayrollMethod: object.deal_applicant.job_payroll_method,
        jobPayrollDate: object.deal_applicant.job_payroll_date,
        jobRetirementAge: object.deal_applicant.job_retirement_age,
      };
    }

    setSubmitDoc({
      ...applicantData,
      id: object.id,
      client:
        object.deal_client && {
          label: object.deal_client ? object.deal_client.name : "",
          value: object.deal_client ? object.deal_client.id : "",
        },
      company:
        object.deal_company && {
          label: object.deal_company ? object.deal_company.name : "",
          value: object.deal_company ? object.deal_company.id : "",
        },
      customer:
        object.deal_customer && {
          label: object.deal_customer ? object.deal_customer.name : "",
          value: object.deal_customer ? object.deal_customer.id : "",
        },
    });

    setPurDocImg(files);
    setIsEdit(true);
    toggleSubmitDoc();
  }

  const handleSubmitLoading = useCallback((id) => {
    setId(id);
  }, [setId]);

  const handleChildProps = (propsFromChild) => {
    dispatch(onUpdateDeals(propsFromChild));
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      company: (deal && deal.company) || companySelected,
      client: (deal && deal.client) || clientSelected,
      image: (deal && deal.image) ?? "",
      description: (deal && deal.description) ?? "",
      value: (deal && deal.value) ?? "",
      tag: deal && deal.tag,
      tagStatus: (deal && deal.tagStatus) ?? "",
      customer: (deal && deal.customer) || [],
      customerContact: (deal && deal.customerContact) ?? "",
      status: (deal && deal.status) ?? "",
      brand: (deal && deal.brand) ?? "",
      branch: (deal && deal.branch) ?? "",
      file: (deal && deal.file) || [],
      startat: (deal && deal.startat) ?? "",
      endat: (deal && deal.endat) ?? "",
      bankat: (deal && deal.bankat) ?? "",
      bank: (deal && deal.bank) ?? "",
      documentat: (deal && deal.documentat) ?? "",
      sp3at: (deal && deal.sp3at) ?? "",
      dealuser: deal && deal.dealuser,
      name: (deal && deal.name) ?? "",
      statusDeal: (deal && deal.statusDeal) ?? "",
      items: (deal && deal.items) || [],
    },
    validationSchema: Yup.object({
      customer: Yup.object().required("Please Select Customer").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateContact = {
          id: deal ? deal.id : 0,
          image: values.image,
          bank: values.bank.value,
          description: values.description,
          value: values.value,
          tag: JSON.stringify(values.tag),
          statusId: values.status.value,
          customerId: values.customer.value,
          customerContactId: values.customerContact.value,
          brandId: values.brand.value,
          branchId: values.branch.value,
          companyId: values.company.value,
          clientId: values.client.value,
          files: values.file.length > 0 ? values.file : [],
          startat: values.startat,
          endat: values.endat,
          bankat: values.bankat,
          documentat: values.documentat,
          sp3at: values.sp3at,
          dealuser: values.dealuser,
          name: values.name,
          statusDealId: values.statusDeal.value,
          deal_product: JSON.stringify(values.items),
        };
        // update Contact
        dispatch(onUpdateDeals(updateContact));
        validation.resetForm();
      } else {
        const newContact = {
          image: values.image,
          description: values.description,
          value: values.value,
          bank: values.bank.value,
          tag: JSON.stringify(values.tag),
          statusId: values.status.value,
          customerId: values.customer.value,
          customerContactId: values.customerContact.value,
          brandId: values.brand.value,
          branchId: values.branch.value,
          companyId: values.company.value,
          clientId: values.client.value,
          files: values.file.length > 0 ? values.file : [],
          startat: values.startat,
          endat: values.endat,
          bankat: values.bankat,
          documentat: values.documentat,
          sp3at: values.sp3at,
          dealuser: values.dealuser,
          name: values.name,
          statusDealId: values.statusDeal.value,
          deal_product: JSON.stringify(values.items),
        };
        // save new Contact
        dispatch(onAddNewDeals(newContact));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationSubmitDoc = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (submitDoc && submitDoc.id) ?? "",
      maritalStatus: (submitDoc && submitDoc.maritalStatus) ?? "",
      name: (submitDoc && submitDoc.name) ?? "",
      email: (submitDoc && submitDoc.email) ?? "",
      phone: (submitDoc && submitDoc.phone) ?? "",
      allocation: (submitDoc && submitDoc.allocation) ?? "",
      creditPeriod: (submitDoc && submitDoc.creditPeriod) ?? "",
      downPayment: (submitDoc && submitDoc.downPayment) ?? "",
      childrenNumber: (submitDoc && submitDoc.childrenNumber) ?? "",
      nameSpouse: (submitDoc && submitDoc.nameSpouse) ?? "",
      phoneSpouse: (submitDoc && submitDoc.phoneSpouse) ?? "",
      knownCrApplication: (submitDoc && submitDoc.knownCrApplication) || false,
      emergencyContactName: (submitDoc && submitDoc.emergencyContactName) ?? "",
      emergencyContactPhone: (submitDoc && submitDoc.emergencyContactPhone) ?? "",
      emergencyContactRelation: (submitDoc && submitDoc.emergencyContactRelation) ?? "",
      emergencyKnownCrApplication: (submitDoc && submitDoc.emergencyKnownCrApplication) || false,
      jobInformanName: (submitDoc && submitDoc.jobInformanName) ?? "",
      jobInformanPosition: (submitDoc && submitDoc.jobInformanPosition) ?? "",
      jobBusiness: (submitDoc && submitDoc.jobBusiness) ?? "",
      jobBusinessEmployee: (submitDoc && submitDoc.jobBusinessEmployee) ?? "",
      jobBusinessDate: (submitDoc && submitDoc.jobBusinessDate) ?? "",
      jobPosition: (submitDoc && submitDoc.jobPosition) ?? "",
      jobDate: (submitDoc && submitDoc.jobDate) ?? "",
      jobStatus: (submitDoc && submitDoc.jobStatus) ?? "",
      jobPayRate: (submitDoc && submitDoc.jobPayRate) ?? "",
      jobPayrollMethod: (submitDoc && submitDoc.jobPayrollMethod) ?? "",
      jobPayrollDate: (submitDoc && submitDoc.jobPayrollDate) ?? "",
      jobRetirementAge: (submitDoc && submitDoc.jobRetirementAge) ?? "",
      client: (submitDoc && submitDoc.client) ?? "",
      company: (submitDoc && submitDoc.company) ?? "",
      customer: (submitDoc && submitDoc.customer) ?? "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      const data = {
        id: values.id,
        applicant: {
          maritalStatusId: values.maritalStatus.value,
          name: values.name,
          email: values.email,
          phone: values.phone,
          allocation: values.allocation,
          credit_period: values.creditPeriod,
          down_payment: values.downPayment,
          children_number: values.childrenNumber,
          name_spouse: values.nameSpouse,
          phone_spouse: values.phoneSpouse,
          knownCrApplication: values.knownCrApplication,
          emergency_contact_name: values.emergencyContactName,
          emergency_contact_phone: values.emergencyContactPhone,
          emergency_contact_relation: values.emergencyContactRelation,
          emergencyKnownCrApplication: values.emergencyKnownCrApplication,
          job_informan_name: values.jobInformanName,
          job_informan_position: values.jobInformanPosition,
          job_business: values.jobBusiness,
          job_business_employee: values.jobBusinessEmployee,
          job_business_date: values.jobBusinessDate,
          job_position: values.jobPosition,
          job_date: values.jobDate,
          job_status: values.jobStatus,
          job_pay_rate: values.jobPayRate,
          job_payroll_method: values.jobPayrollMethod,
          job_payroll_date: values.jobPayrollDate,
          job_retirement_age: values.jobRetirementAge,
        },
        files: purDocImg.length > 0 ? purDocImg : [],
        clientId: values.client.value,
        companyId: values.company.value,
        customerId: values.customer.value,
      };
      dispatch(onUpdateDeals(data));
      validationSubmitDoc.resetForm();
      toggleSubmitDoc();
      dispatch(onGetDeals());
    },
  });

  const components = {
    Card: (props) => <CardBoard idCard={id} handleSubmitLoading={handleSubmitLoading} isLoadingDeal={loading} onChildProps={handleChildProps} handleToggleSubmitDoc={handleToggleSubmitDoc} handleToggleBooking={handleToggleBooking} handleContactClick={handleContactClick} handleFollowUpClick={handleFollowUpClick} {...props} />,
  };


  document.title = "CRM Deals | Enterprise Resources Planning";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Deals" pageTitle="CRM">
            <Row className="g-3 flex-grow-1">
              <Col md={3} className="d-flex align-items-center gap-2">
                <div className="search-box">
                  <Input
                    onChange={(e) => {
                      searchHandleDeal(e.target.value);
                    }}
                    type="text"
                    className="form-control search"
                    placeholder="Search for deals..."/>
                  <i className="ri-search-line search-icon"></i>
                </div>
                {loading ? (
                  <div className="d-flex">
                    <Spinner color="primary" type="grow" size={"sm"}>
                      Loading...
                    </Spinner>
                    &nbsp;
                    <Spinner color="success" type="grow" size={"sm"}>
                      Loading...
                    </Spinner>
                    &nbsp;
                  </div>
                ) : null}
              </Col>
              <div className="col-md-auto ms-auto">
                <div className="d-flex hastck gap-2 flex-wrap">
                  <button className="btn btn-success" onClick={toggle}>
                    <i className="ri-add-fill align-bottom me-1"></i> Add Deals
                  </button>
                </div>
              </div>
            </Row>
          </BreadCrumb>
          <div>
            <Board
              data={dataBoard}
              components={components}
              // onBeforeCardDelete={(e) => {
              //   e();
              // }}
              onDataChange={(e) => {

              }}
              handleDragEnd={(cardId, sourceLaneId, targetLaneId, position) => {
                let object = deals.find((obj) => obj.id.toString() === cardId.toString());
                let objectStatusFind = dataBoard.lanes.find((obj) => obj.id.toString() === targetLaneId.toString());

                if (object.statusDealId.toString() !== targetLaneId.toString()) {
                  let data = {
                    // ...object,
                    id: object.id,
                    type: "Status",
                    companyId: object.companyId,
                    clientId: object.clientId,
                    statusDealId: targetLaneId.toString(),
                  };

                  if (object.deal_status_type.sort_order < 5 && 3 === objectStatusFind.sortOrder) {
                    handleFollowUpClick(object, "Reject Document");
                  } else {
                    if (object.deal_status_type.sort_order + 1 === objectStatusFind.sortOrder) {
                      if (objectStatusFind.title === "SUBMIT DOCUMENT") {
                        handleToggleSubmitDoc(data, object);
                      } else if (objectStatusFind.title === "BANK VERIFICATION") {
                        handleFollowUpClick(object, "Approve Document");
                      } else if (objectStatusFind.title === "PEMBERKASAN AKAD") {
                        handleFollowUpClick(object, "Approve Bank");
                      } else {
                        dispatch(onUpdateDeals(data));
                      }
                    } else {
                      toast.error("Drag and drop is invalid", { autoClose: 3000 });
                      return false;
                    }
                  }
                }
              }}
            />
          </div>
        </Container>
      </div>

      <Modal id="adddeals" isOpen={modal} toggle={toggle} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          Create Deals
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>
          <ModalBody>
            <Row>
              <Col lg={4}>
                <Card>
                  <CardHeader className="bg-light ps-3 pe-3 pt-3 pb-2">
                    <h5 className="card-title mb-0">Deals Identity</h5>
                  </CardHeader>
                  <CardBody>
                    <div className="mb-3">
                      <Label htmlFor="client-field" className="form-label">
                        Grup Usaha&nbsp;
                        {clientLoading && (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        )}
                      </Label>
                      <Select
                        name="client"
                        value={validation.values.client}
                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                        placeholder="Pilih Grup Usaha"
                        onChange={(e) => {
                          setBranchList([]);
                          validation.setFieldValue("branch", "");
                          validation.setFieldValue("dealuser", "");
                          setCompanyList([]);
                          validation.setFieldValue("company", "");
                          validation.setFieldValue("client", e);
                          handleGetCompany(e.value);
                        }}
                        options={clientList}></Select>
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="company-field" className="form-label">
                        Perusahaan&nbsp;
                        {companyLoading ? (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        ) : (
                          ""
                        )}
                      </Label>
                      <Select
                        name="company"
                        value={validation.values.company}
                        placeholder="Pilih Perusahaan"
                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                        onChange={(e) => {
                          setBranchList([]);
                          validation.setFieldValue("branch", "");
                          validation.setFieldValue("dealuser", "");
                          validation.setFieldValue("company", e);
                          handleGetBranch(e.value);
                          handleGetProductVariant(e.value);
                        }}
                        options={companyList}></Select>
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="company-field" className="form-label">
                        Branch&nbsp;
                        {branchLoading ? (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        ) : (
                          ""
                        )}
                      </Label>
                      <Select
                        name="branch"
                        value={validation.values.branch}
                        placeholder="Select Branch"
                        onChange={(e) => {
                          validation.setFieldValue("branch", e);
                          handleGetBrand(e.value);
                        }}
                        options={branchList}></Select>
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="company-field" className="form-label">
                        Brand&nbsp;
                        {brandLoading ? (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        ) : (
                          ""
                        )}
                      </Label>
                      <Select
                        name="brand"
                        value={validation.values.brand}
                        placeholder="Select Branch"
                        onChange={(e) => {
                          validation.setFieldValue("brand", e);
                        }}
                        options={brandList}></Select>
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="type-field" className="form-label">
                        Customer
                      </Label>
                      <Select
                        name="customer"
                        value={validation.values.customer}
                        placeholder="Select Customer"
                        onChange={(e) => {
                          validation.setFieldValue("customer", e);
                        }}
                        options={customerList}></Select>
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="assignto" className="form-label">
                        Marketing&nbsp;
                        {agentLoading ? (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        ) : (
                          ""
                        )}
                      </Label>
                      <Select
                        name="assignto"
                        value={validation.values.dealuser}
                        placeholder="Select Marketing"
                        isMulti
                        onChange={(opt, { option }) => {
                          let newOpts = opt;
                          if (option && option.value === "all") {
                            let filteredOptions = clone(agentList);
                            filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                            newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                          }
                          validation.setFieldValue("dealuser", newOpts);
                        }}
                        options={agentList}
                        noOptionsMessage={(e) => "Type User to get option"}
                        invalid={validation.touched.dealuser && validation.errors.dealuser ? true : false}></Select>
                      {validation.touched.dealuser && validation.errors.dealuser ? (
                        <small className="text-danger" type="invalid">
                          {validation.errors.dealuser}
                        </small>
                      ) : null}
                    </div>
                  </CardBody>
                </Card>
                {/* Text */}
              </Col>
              <Col lg={8}>
                {/* <div className="mb-3">
                  <Label htmlFor="des-field" className="form-label">
                    Name
                  </Label>
                  <Input name="name" id="des-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} validate={{ required: { value: true } }} value={validation.values.name ?? ""} />
                  {validation.touched.name && validation.errors.name ? (
                    <p className="invalid-feedback d-block" type="invalid">
                      {validation.errors.name}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label htmlFor="des-field" className="form-label">
                    Value
                  </Label>
                  <Input name="value" id="des-field" className="form-control" placeholder="Enter Value" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.value ?? ""} />
                </div> */}

                <Row>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label htmlFor="des-field" className="form-label">
                        Tanggal Dokumen
                      </Label>
                      <Flatpickr
                        name="date-picker"
                        className="form-control"
                        placeholder="Select end date"
                        options={{
                          enableTime: false,
                          altInput: true,
                          altFormat: "Y/m/d",
                          dateFormat: "Y/m/d",
                        }}
                        value={validation.values.documentat ?? ""}
                        onChange={(obj, str) => {
                          handleDocumentAt(str);
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label htmlFor="des-field" className="form-label">
                        Tanggal Bank
                      </Label>
                      <Flatpickr
                        name="date-picker"
                        className="form-control"
                        placeholder="Select end date"
                        options={{
                          enableTime: false,
                          altInput: true,
                          altFormat: "Y/m/d",
                          dateFormat: "Y/m/d",
                        }}
                        value={validation.values.bankat ?? ""}
                        onChange={(obj, str) => {
                          handleBankat(str);
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label htmlFor="des-field" className="form-label">
                        Tanggal SP3
                      </Label>
                      <Flatpickr
                        name="date-picker"
                        className="form-control"
                        placeholder="Select end date"
                        options={{
                          enableTime: false,
                          altInput: true,
                          altFormat: "Y/m/d",
                          dateFormat: "Y/m/d",
                        }}
                        value={validation.values.sp3at ?? ""}
                        onChange={(obj, str) => {
                          handleSp3at(str);
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label htmlFor="des-field" className="form-label">
                        Tanggal Akad
                      </Label>
                      <Flatpickr
                        name="date-picker"
                        className="form-control"
                        placeholder="Select end date"
                        options={{
                          enableTime: false,
                          altInput: true,
                          altFormat: "Y/m/d",
                          dateFormat: "Y/m/d",
                        }}
                        value={validation.values.endat ?? ""}
                        onChange={(obj, str) => {
                          handleEndAt(str);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                     
                    <div className="mb-3">
                      <Label htmlFor="type-field" className="form-label">
                        Status Deal
                      </Label>
                      <Select
                        name="statusDeal"
                        value={validation.values.statusDeal}
                        placeholder="Select Status Deal"
                        onChange={(e) => {
                          validation.setFieldValue("statusDeal", e);
                        }}
                        options={dealStatusList}></Select>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <Label htmlFor="type-field" className="form-label">
                      Tag
                    </Label>
                    <div className="mb-3">
                      <Select
                        name="tag"
                        value={validation.values.tag}
                        placeholder="Select deal tag"
                        isMulti
                        onChange={(opt, { option }) => {
                          let newOpts = opt;
                          if (option && option.value === "all") {
                            let filteredOptions = clone(dealTagList);
                            filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                            newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                          }
                          validation.setFieldValue("tag", newOpts);
                        }}
                        options={dealTagList}></Select>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label htmlFor="type-field" className="form-label">
                        Bank
                      </Label>
                      <Select
                        name="bank"
                        value={validation.values.bank}
                        placeholder="Select Bank"
                        onChange={(e) => {
                          validation.setFieldValue("bank", e);
                        }}
                        options={statusActiveData}></Select>
                    </div>
                  </Col>
                </Row>
                <div className="mb-3">
                  <Label htmlFor="des-field" className="form-label">
                    Description
                  </Label>
                  <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                </div>
                <Row>
                  <Table className="invoice-table table-borderless table-nowrap mb-0">
                    <thead className="align-middle">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Product</th>
                      </tr>
                    </thead>
                    <tbody id="newlink">
                      {validation.values.items.map((o, i) => {
                        return (
                          <tr key={i} id={i} className="product">
                            <th scope="row" className="product-id" style={{ width: "20px" }}>
                              {i + 1}
                            </th>
                            <td className="text-start" style={{ maxWidth: "250px" }}>
                              <Select
                                name="item"
                                value={validation.values.items[i].item ?? ""}
                                placeholder="Select Product"
                                onChange={(e) => {
                                  let itemsCopy = [...validation.values.items];
                                  itemsCopy[i].item = e;
                                  itemsCopy[i].productVarianId = e.value;
                                  itemsCopy[i].productId = e.productId;

                                  validation.setFieldValue("items", itemsCopy);
                                }}
                                options={productList}
                                validate={{ required: { value: true } }}
                                invalid={validation.touched.item && validation.errors.item ? true : false}></Select>
                              {validation.touched.item && validation.errors.item ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.item}
                                </p>
                              ) : null}
                            </td>
                            <td className="product-removal">
                              <Link
                                to="#"
                                className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                onClick={() => {
                                  // const data = salesDetailItem[i];
                                  onClickDeleteDetailItem(i);
                                }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tbody>
                      <tr>
                        <td className="10">
                          {validation.touched.items && validation.errors.items && (
                            <small className="text-danger" type="invalid">
                              {validation.errors.items}
                            </small>
                          )}
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr id="newForm" style={{ display: "none" }}>
                        <td className="d-none" colSpan="5">
                          <p>Tambah Form</p>
                        </td>
                      </tr>
                      {validation.values.company !== "" ? (
                        <tr>
                          <td colSpan="5">
                            <Link
                              to="#"
                              className="btn btn-soft-success fw-medium"
                              id="add-item"
                              onClick={() => {
                                handleSalesDetailAdd();
                              }}><i className="ri-add-fill me-1 align-bottom"></i>Add Item
                            </Link>
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </Table>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3 d-flex justify-content-between">
                      <Label htmlFor="image" className="form-label">
                        Image
                      </Label>
                      <button
                        type="button"
                        className="btn btn-sm btn-label btn-soft-success" onClick={() => {
                          setMediaType("image");
                          toggleMedia();
                        }}>
                        <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                      </button>
                    </div>
                    {validation.values.image !== "" ? (
                      <div className="border-bottom mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div className="me-2">
                            <img src={validation.values.image === "" ? defaultImg : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                          </div>

                          <div className="text-truncate">{validation.values.image}</div>
                          <div>
                            <Link
                              to="#"
                              className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                              onClick={(e) => {
                                // e.stopPropagation();
                                validation.setFieldValue("image", "");
                              }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3 d-flex justify-content-between">
                      <Label htmlFor="taskFiles" className="form-label me-3">
                        Deal Files
                      </Label>
                      <button
                        type="button"
                        className="btn btn-sm btn-label btn-soft-success" onClick={() => {
                          setMediaType("files");
                          toggleMedia();
                        }}>
                        <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                      </button>
                    </div>
                    {validation.values.file.map((productFile, i) => {
                      if (productFile.isDeleted || productFile.statusId === 3) {
                        return null;
                      } else {
                        return (
                          <div key={i} className="border-bottom mb-3">
                            <div className="d-flex justify-content-between mb-3 align-items-center">
                              <div className="me-2 d-flex align-items-center gap-2">
                                <img src={productFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${productFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                <div className="text-truncate">{productFile.originalname}</div>
                              </div>

                              <div>
                                <Link
                                  to="#"
                                  className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                  onClick={(e) => {
                                    // e.stopPropagation();
                                    handleDeleteFile(productFile);
                                  }}>
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="light"
              id="close-modal"
              onClick={() => {
                // setModal(false);
                // setDealFiles([]);
                toggle();
              }}>
              Close
            </Button>
            <Button type="submit" color="success">
              <i className="ri-save-line align-bottom me-1"></i> Save
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal id="showModal" isOpen={modalBooking} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={toggleBooking}>Sales Booking Invoice</ModalHeader>
        {salesBook && (
          <ModalBody>
            <Row id="printThis">
              <Col lg={12}>
                <CardHeader className="border-bottom-dashed p-4">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                      <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                      <div className="mt-sm-3 mt-3">
                        <h6 className="text-uppercase fw-semibold">{salesBook.client && salesBook.client.label}</h6>
                        <p className="mb-1">{salesBook.company && salesBook.company.label}</p>
                        <p className="mb-1">{salesBook.salesChannel && salesBook.salesChannel.label}</p>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="p-4">
                  <Row className="g-3">
                    <Col lg={3} xs={3}>
                      <p className="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                      <h5 className="fs-14 mb-0">
                        #<span id="invoice-no">{salesBook.code}</span>
                      </h5>
                    </Col>
                    <Col lg={3} xs={3}>
                      <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                      <h5 className="fs-14 mb-0">
                        <span id="invoice-date">{handleValidDate(salesBook.transactionat)}</span>
                      </h5>
                    </Col>
                    <Col lg={3} xs={3}>
                      <p className="text-muted mb-2 text-uppercase fw-semibold">Total Amount</p>
                      <h5 className="fs-14 mb-0">
                        <span id="total-amount">{currencyFormat(salesBook.totalAmount)}</span>
                      </h5>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody className="p-4">
                  <div>
                    <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                      <thead>
                        <tr className="table-active">
                          <th scope="col" style={{ width: "50px" }}>
                            #
                          </th>
                          <th scope="col">Detail Produk</th>
                          <th scope="col">Rate</th>
                          <th scope="col">Quantity</th>
                          <th scope="col" className="text-end">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody id="products-list">
                        {(salesBookDetailItem || []).map((o, i) => {
                          return (
                            <tr key={i} id={i} className="product">
                              <th scope="row" className="product-id">
                                {i + 1}
                              </th>
                              <td className="text-start">{o.name}</td>
                              <td>{currencyFormat(o.amount)}</td>
                              <td>{o.quantity}</td>
                              <td className="text-end">{currencyFormat(o.total)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <div className="border-top border-top-dashed mt-2">
                    <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                      <tbody>
                        <tr>
                          <td>Sub Total</td>
                          <td className="text-end">{currencyFormat(subTotal)}</td>
                        </tr>
                        <tr>
                          <td>Diskon</td>
                          <td className="text-end">{currencyFormat(salesBook.discount)}</td>
                        </tr>
                        <tr>
                          <td>Pajak ({salesBook.tax !== undefined && salesBook.tax !== "" ? salesBook.tax.amount : 0}%)</td>
                          <td className="text-end">{currencyFormat(salesBook.taxAmount)}</td>
                        </tr>
                        <tr className="border-top border-top-dashed fs-15">
                          <th scope="row">Total Amount</th>
                          <th className="text-end">{currencyFormat(salesBook.totalAmount)}</th>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  <div className="mt-4">
                    <div className="alert alert-info">
                      <p className="mb-0">
                        <span className="fw-semibold">NOTES:</span>
                        <span id="note"> {salesBook.description}</span>
                      </p>
                    </div>
                  </div>
                  <div className="mt-4">
                    <div>
                      <p className="mb-0">{salesBook.user}</p>
                    </div>
                  </div>
                </CardBody>
              </Col>
            </Row>
          </ModalBody>
        )}
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">

            <button
              type="button"
              className="btn btn-light"
              onClick={() => {
                toggleBooking();
              }}>
               
              Close 
            </button>
          </div>
        </div>
      </Modal>

      <Modal id="showModalSubmitDoc" isOpen={modalSubmitDoc} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={toggleSubmitDoc}>
          {!!isEdit ? "Edit Submit Dokumen Verifikasi KPR" : "Add Submit Dokumen Verifikasi KPR"}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validationSubmitDoc.handleSubmit();
            return false;
          }}>
          <ModalBody>
            {/* SPOUSE */}
            <div className="row">
              <div className="col-lg-4">
                <h5 className="mb-3">Applicant Data</h5>
                <div className="mb-3">
                  <Label htmlFor="name-field" className="form-label">
                    Name
                  </Label>
                  <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.name ?? ""} invalid={validationSubmitDoc.touched.name && validationSubmitDoc.errors.name ? true : false} />
                  {validationSubmitDoc.touched.name && validationSubmitDoc.errors.name ? <FormFeedback type="invalid">{validationSubmitDoc.errors.name}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Label htmlFor="email-field" className="form-label">
                    Email
                  </Label>
                  <Input name="email" id="email-field" className="form-control" placeholder="Enter Email" type="email" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.email ?? ""} invalid={validationSubmitDoc.touched.email && validationSubmitDoc.errors.email ? true : false} />
                  {validationSubmitDoc.touched.email && validationSubmitDoc.errors.email ? <FormFeedback type="invalid">{validationSubmitDoc.errors.email}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Label htmlFor="phone-field" className="form-label">
                    Phone
                  </Label>
                  <Input name="phone" id="phone-field" className="form-control" placeholder="Enter Phone" type="phone" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.phone ?? ""} invalid={validationSubmitDoc.touched.phone && validationSubmitDoc.errors.phone ? true : false} />
                  {validationSubmitDoc.touched.phone && validationSubmitDoc.errors.phone ? <FormFeedback type="invalid">{validationSubmitDoc.errors.phone}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Label htmlFor="maritalStatus-field" className="form-label">
                    Marital Status&nbsp;
                    {maritalLoading ? (
                      <Spinner color="primary" size="sm">
                        Loading...
                      </Spinner>
                    ) : (
                      ""
                    )}
                  </Label>
                  <Select
                    name="maritalStatus"
                    value={validationSubmitDoc.values.maritalStatus}
                    placeholder="Select Marital Status"
                    onChange={(e) => {
                      validationSubmitDoc.setFieldValue("maritalStatus", e);
                    }}
                    options={maritalList}> </Select>
                </div>
                <div className="mb-3">
                  <Label htmlFor="allocation-field" className="form-label">
                    Allocation
                  </Label>
                  <Input name="allocation" id="allocation-field" className="form-control" placeholder="Enter Allocation" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.allocation ?? ""} invalid={validationSubmitDoc.touched.allocation && validationSubmitDoc.errors.allocation ? true : false} />
                  {validationSubmitDoc.touched.allocation && validationSubmitDoc.errors.allocation ? <FormFeedback type="invalid">{validationSubmitDoc.errors.allocation}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Label htmlFor="downPayment-field" className="form-label">
                    DP
                  </Label>
                  <Input name="downPayment" id="downPayment-field" className="form-control" placeholder="Enter DP" type="number" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.downPayment ?? ""} invalid={validationSubmitDoc.touched.downPayment && validationSubmitDoc.errors.downPayment ? true : false} />
                  {validationSubmitDoc.touched.downPayment && validationSubmitDoc.errors.downPayment ? <FormFeedback type="invalid">{validationSubmitDoc.errors.downPayment}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Label htmlFor="creditPeriod-field" className="form-label">
                    Credit Period
                  </Label>
                  <Input name="creditPeriod" id="creditPeriod-field" className="form-control" placeholder="Enter Credit Period" type="number" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.creditPeriod ?? ""} invalid={validationSubmitDoc.touched.creditPeriod && validationSubmitDoc.errors.creditPeriod ? true : false} />
                  {validationSubmitDoc.touched.creditPeriod && validationSubmitDoc.errors.creditPeriod ? <FormFeedback type="invalid">{validationSubmitDoc.errors.creditPeriod}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Label htmlFor="childrenNumber-field" className="form-label">
                    Number Of Children
                  </Label>
                  <Input name="childrenNumber" id="childrenNumber-field" className="form-control" placeholder="Enter Number of children" type="number" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.childrenNumber ?? ""} invalid={validationSubmitDoc.touched.childrenNumber && validationSubmitDoc.errors.childrenNumber ? true : false} />
                  {validationSubmitDoc.touched.childrenNumber && validationSubmitDoc.errors.childrenNumber ? <FormFeedback type="invalid">{validationSubmitDoc.errors.childrenNumber}</FormFeedback> : null}
                </div>
              </div>
              <div className="col-lg-4">
                <h5 className="mb-3">Spouse Data</h5>
                <div className="mb-3">
                  <Label htmlFor="nameSpouse-field" className="form-label">
                    Name
                  </Label>
                  <Input name="nameSpouse" id="nameSpouse-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.nameSpouse ?? ""} invalid={validationSubmitDoc.touched.nameSpouse && validationSubmitDoc.errors.nameSpouse ? true : false} />
                  {validationSubmitDoc.touched.nameSpouse && validationSubmitDoc.errors.nameSpouse ? <FormFeedback type="invalid">{validationSubmitDoc.errors.nameSpouse}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="phoneSpouse-field" className="form-label">
                    Phone
                  </Label>
                  <Input name="phoneSpouse" id="phoneSpouse-field" className="form-control" placeholder="Enter Phone" type="phone" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.phoneSpouse ?? ""} invalid={validationSubmitDoc.touched.phoneSpouse && validationSubmitDoc.errors.phoneSpouse ? true : false} />
                  {validationSubmitDoc.touched.phoneSpouse && validationSubmitDoc.errors.phoneSpouse ? <FormFeedback type="invalid">{validationSubmitDoc.errors.phoneSpouse}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Input name="knownCrApplication" id="knownCrApplication-field" className="form-check-input" type="checkbox" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} checked={validationSubmitDoc.values.knownCrApplication} /> &nbsp;
                  <Label htmlFor="knownCrApplication-field" className="form-label">
                    Mengetahui KPR
                  </Label>
                </div>
                <h5 className="mb-3 pt-3">Emergency Contact Data</h5>
                <div className="mb-3">
                  <Label htmlFor="emergencyContactName-field" className="form-label">
                    Name
                  </Label>
                  <Input name="emergencyContactName" id="emergencyContactName-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.emergencyContactName ?? ""} invalid={validationSubmitDoc.touched.emergencyContactName && validationSubmitDoc.errors.emergencyContactName ? true : false} />
                  {validationSubmitDoc.touched.emergencyContactName && validationSubmitDoc.errors.emergencyContactName ? <FormFeedback type="invalid">{validationSubmitDoc.errors.emergencyContactName}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="emergencyContactPhone-field" className="form-label">
                    Phone
                  </Label>
                  <Input name="emergencyContactPhone" id="emergencyContactPhone-field" className="form-control" placeholder="Enter Phone" type="phone" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.emergencyContactPhone ?? ""} invalid={validationSubmitDoc.touched.emergencyContactPhone && validationSubmitDoc.errors.emergencyContactPhone ? true : false} />
                  {validationSubmitDoc.touched.emergencyContactPhone && validationSubmitDoc.errors.emergencyContactPhone ? <FormFeedback type="invalid">{validationSubmitDoc.errors.emergencyContactPhone}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="emergencyContactRelation-field" className="form-label">
                    Relation
                  </Label>
                  <Input name="emergencyContactRelation" id="emergencyContactRelation-field" className="form-control" placeholder="Enter Relation" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.emergencyContactRelation ?? ""} invalid={validationSubmitDoc.touched.emergencyContactRelation && validationSubmitDoc.errors.emergencyContactRelation ? true : false} />
                  {validationSubmitDoc.touched.emergencyContactRelation && validationSubmitDoc.errors.emergencyContactRelation ? <FormFeedback type="invalid">{validationSubmitDoc.errors.emergencyContactRelation}</FormFeedback> : null}
                </div>
                <div className="mb-3">
                  <Input name="emergencyKnownCrApplication" id="emergencyKnownCrApplication-field" className="form-check-input" type="checkbox" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} checked={validationSubmitDoc.values.emergencyKnownCrApplication} /> &nbsp;
                  <Label htmlFor="emergencyKnownCrApplication-field" className="form-label">
                    Mengetahui KPR
                  </Label>
                </div>
              </div>

              <div className="col-lg-4">
                <h5 className="mb-3">Workplace Data</h5>
                <div className="mb-3">
                  <Label htmlFor="jobInformanName-field" className="form-label">
                    Informan Name
                  </Label>
                  <Input name="jobInformanName" id="jobInformanName-field" className="form-control" placeholder="Enter Informan Name" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobInformanName ?? ""} invalid={validationSubmitDoc.touched.jobInformanName && validationSubmitDoc.errors.jobInformanName ? true : false} />
                  {validationSubmitDoc.touched.jobInformanName && validationSubmitDoc.errors.jobInformanName ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobInformanName}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobInformanPosition-field" className="form-label">
                    Informan Position
                  </Label>
                  <Input name="jobInformanPosition" id="jobInformanPosition-field" className="form-control" placeholder="Enter Informan Position" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobInformanPosition ?? ""} invalid={validationSubmitDoc.touched.jobInformanPosition && validationSubmitDoc.errors.jobInformanPosition ? true : false} />
                  {validationSubmitDoc.touched.jobInformanPosition && validationSubmitDoc.errors.jobInformanPosition ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobInformanPosition}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobBusiness-field" className="form-label">
                    field Of Business
                  </Label>
                  <Input name="jobBusiness" id="jobBusiness-field" className="form-control" placeholder="Enter field Of Business" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobBusiness ?? ""} invalid={validationSubmitDoc.touched.jobBusiness && validationSubmitDoc.errors.jobBusiness ? true : false} />
                  {validationSubmitDoc.touched.jobBusiness && validationSubmitDoc.errors.jobBusiness ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobBusiness}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobPosition-field" className="form-label">
                    Applicant Position
                  </Label>
                  <Input name="jobPosition" id="jobPosition-field" className="form-control" placeholder="Enter Applicant Position" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobPosition ?? ""} invalid={validationSubmitDoc.touched.jobPosition && validationSubmitDoc.errors.jobPosition ? true : false} />
                  {validationSubmitDoc.touched.jobPosition && validationSubmitDoc.errors.jobPosition ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobPosition}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobDate-field" className="form-label">
                    Job Date
                  </Label>
                  <Flatpickr
                    name="jobDate"
                    className="form-control"
                    placeholder="Select date"
                    options={{ enableTime: false, dateFormat: "Y/m/d" }}
                    value={validationSubmitDoc.values.jobDate ?? ""}
                    onChange={(o, e) => {
                      validationSubmitDoc.setFieldValue("jobDate", e);
                    }}/>
                  {validationSubmitDoc.touched.jobDate && validationSubmitDoc.errors.jobDate ? (
                    <p className="text-danger" type="invalid">
                      {validationSubmitDoc.errors.jobDate}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobStatus-field" className="form-label">
                    Job Status
                  </Label>
                  <Input name="jobStatus" id="jobStatus-field" className="form-control" placeholder="Enter Job Status" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobStatus ?? ""} invalid={validationSubmitDoc.touched.jobStatus && validationSubmitDoc.errors.jobStatus ? true : false} />
                  {validationSubmitDoc.touched.jobStatus && validationSubmitDoc.errors.jobStatus ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobStatus}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobPayRate-field" className="form-label">
                    Payrate Amount
                  </Label>
                  <Input name="jobPayRate" id="jobPayRate-field" className="form-control" placeholder="Enter Payrate Amount" type="number" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobPayRate ?? ""} invalid={validationSubmitDoc.touched.jobPayRate && validationSubmitDoc.errors.jobPayRate ? true : false} />
                  {validationSubmitDoc.touched.jobPayRate && validationSubmitDoc.errors.jobPayRate ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobPayRate}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobPayrollMethod-field" className="form-label">
                    Payroll Method
                  </Label>
                  <Input name="jobPayrollMethod" id="jobPayrollMethod-field" className="form-control" placeholder="Enter Payroll Method" type="text" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobPayrollMethod ?? ""} invalid={validationSubmitDoc.touched.jobPayrollMethod && validationSubmitDoc.errors.jobPayrollMethod ? true : false} />
                  {validationSubmitDoc.touched.jobPayrollMethod && validationSubmitDoc.errors.jobPayrollMethod ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobPayrollMethod}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobPayrollDate-field" className="form-label">
                    Payroll Date
                  </Label>
                  <Flatpickr
                    name="jobPayrollDate"
                    className="form-control"
                    placeholder="Select Date"
                    options={{ enableTime: false, dateFormat: "Y/m/d" }}
                    value={validationSubmitDoc.values.jobPayrollDate ?? ""}
                    onChange={(o, e) => {
                      validationSubmitDoc.setFieldValue("jobPayrollDate", e);
                    }}/>
                  {validationSubmitDoc.touched.jobPayrollDate && validationSubmitDoc.errors.jobPayrollDate ? (
                    <p className="text-danger" type="invalid">
                      {validationSubmitDoc.errors.jobPayrollDate}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobRetirementAge-field" className="form-label">
                    Retirement Age
                  </Label>
                  <Input name="jobRetirementAge" id="jobRetirementAge-field" className="form-control" placeholder="Enter Retirement Age" type="number" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobRetirementAge ?? ""} invalid={validationSubmitDoc.touched.jobRetirementAge && validationSubmitDoc.errors.jobRetirementAge ? true : false} />
                  {validationSubmitDoc.touched.jobRetirementAge && validationSubmitDoc.errors.jobRetirementAge ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobRetirementAge}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobBusinessEmployee-field" className="form-label">
                    Number Of Employee
                  </Label>
                  <Input name="jobBusinessEmployee" id="jobBusinessEmployee-field" className="form-control" placeholder="Enter Number Of Employee" type="number" onChange={validationSubmitDoc.handleChange} onBlur={validationSubmitDoc.handleBlur} value={validationSubmitDoc.values.jobBusinessEmployee ?? ""} invalid={validationSubmitDoc.touched.jobBusinessEmployee && validationSubmitDoc.errors.jobBusinessEmployee ? true : false} />
                  {validationSubmitDoc.touched.jobBusinessEmployee && validationSubmitDoc.errors.jobBusinessEmployee ? <FormFeedback type="invalid">{validationSubmitDoc.errors.jobBusinessEmployee}</FormFeedback> : null}
                </div>

                <div className="mb-3">
                  <Label htmlFor="jobBusinessDate-field" className="form-label">
                    Business Date
                  </Label>
                  <Flatpickr
                    name="jobBusinessDate"
                    className="form-control"
                    placeholder="Select Date"
                    options={{ enableTime: false, dateFormat: "Y/m/d" }}
                    value={validationSubmitDoc.values.jobBusinessDate ?? ""}
                    onChange={(o, e) => {
                      validationSubmitDoc.setFieldValue("jobBusinessDate", e);
                    }}/>
                  {validationSubmitDoc.touched.jobBusinessDate && validationSubmitDoc.errors.jobBusinessDate ? (
                    <p className="text-danger" type="invalid">
                      {validationSubmitDoc.errors.jobBusinessDate}
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="mb-3 pt-3 d-flex justify-content-between">
              <Label htmlFor="document" className="form-label">
                Document
              </Label>
              <button
                type="button"
                className="btn btn-sm btn-label btn-soft-success"
                onClick={() => {
                  // setMediaType("other");
                  toggleMediaSubmitDoc();
                }}>
                <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
              </button>
            </div>
            {purDocImg.map((f, i) => {
              if (f.isDeleted) {
                return null;
              } else {
                return (
                  <div key={i} className="border-bottom mb-3">
                    <div className="d-flex justify-content-between mb-3 align-items-center">
                      <div className="d-flex align-items-center ">
                        <div className="me-2">
                          <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                        </div>

                        <div className="text-truncate">{f.filename}</div>
                      </div>
                      <div>
                        <Link
                          to="#"
                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                          onClick={(e) => {
                            // e.stopPropagation();
                            handleDeleteFileSubmitDoc(f);
                          }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </ModalBody>
          <div className="modal-footer">
            <div className="d-flex justify-content-between w-100">
              <div className="hstack gap-2 justify-content-end">
                {deal && deal.statusDealId < 5 ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleFollowUpClick(deal && deal, "Approve Document");
                        // toggleSubmitDoc();
                      }}>
                      Approve
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => {
                        handleFollowUpClick(deal && deal, "Reject Document");
                        // toggleSubmitDoc();
                      }}>
                      Reject
                    </button>
                  </>
                ) : null}

                {deal && deal.statusDealId === 5 ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleFollowUpClick(deal && deal, "Approve Bank");
                        // toggleSubmitDoc();
                      }}>
                      Approve Bank
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => {
                        handleFollowUpClick(deal && deal, "Reject Bank");
                        // toggleSubmitDoc();
                      }}>
                      Reject Bank
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={() => {
                        handleFollowUpClick(deal && deal, "Reject Banding Bank");
                        // toggleSubmitDoc();
                      }}>
                      Reject Banding Bank
                    </button>
                  </>
                ) : null}
                {/* <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add"}</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button> */}
              </div>
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    toggleSubmitDoc();
                  }}>
                  Close
                </button>

                {deal && deal.statusDealId < 5 && (
                  <button type="submit" className="btn btn-success">
                    <span className="d-flex align-items-center">
                      <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add"}</span>
                      {loading && (
                        <Spinner size="sm" className="flex-shrink-0" role="status">
                          Loading...
                        </Spinner>
                      )}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </Form>
      </Modal>

      <Modal id="showModal" isOpen={modalFollowUp} centered size="md">
        <ModalHeader className="bg-light p-3" toggle={toggleFollowUp}>
          {followUpData && followUpData.type}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validationFollowUp.handleSubmit();
            return false;
          }}>
          <ModalBody>
            <div className="row">
              <div className="mb-3 col-lg-12">
                <Label htmlFor="description-field" className="form-label">
                  Description
                </Label>
                <Input name="description" id="description-field" rows="7" className="form-control" placeholder="Enter Task Description" type="textarea" onChange={validationFollowUp.handleChange} onBlur={validationFollowUp.handleBlur} value={validationFollowUp.values.description} />
              </div>
            </div>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  toggleFollowUp();
                }}> Close
              </button>
              <button type="submit" className="btn btn-success">
                <span className="d-flex align-items-center">
                  <span className="flex-grow-1 me-2">{"Update"}</span>
                  {loading && (
                    <Spinner size="sm" className="flex-shrink-0" role="status">
                      Loading...
                    </Spinner>
                  )}
                </span>
              </button>
            </div>
          </div>
        </Form>
      </Modal>

      
      <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
      <ModalInputFile onSelect={handleSelectFileBooking} loading={loading} modal={modalMediaBooking} toggle={toggleMediaBooking} />
      <ModalInputFile onSelect={handleSelectFileSubmitDoc} loading={loading} modal={modalMediaSubmitDoc} toggle={toggleMediaSubmitDoc} />
    </React.Fragment>
  );
};

export default CrmDeals;
